import { render, staticRenderFns } from "./KnDocItem.vue?vue&type=template&id=cab8ce7a"
import script from "./KnDocItem.vue?vue&type=script&lang=js"
export * from "./KnDocItem.vue?vue&type=script&lang=js"
import style0 from "./KnDocItem.vue?vue&type=style&index=0&id=cab8ce7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports